module.exports = __webpack_public_path__ + "static/everyplate_logo-f951d612a28bc2b8742c84ce695295cf.png";